import { useEffect, useState } from "react";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import Loader from "../component/loading-screen/Loader";
import { okSuccessToast, apiErrorToast } from "../utils/ToastUtil";

const Bbps2 = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const payload = {
      operatorCode: 30,
    };

    postJsonData(
      ApiEndpoints.BBPS_2,
      payload,
      setLoading,
      (res) => {
        console.log("BBPS_2 SUCCESS", res);

        okSuccessToast("Redirecting...");

        const link = res?.data?.link;

        if (link) {
          // Same tab
          window.location.href = link;

          // Agar new tab me kholna ho to is line ko use karo:
          // window.open(link, "_blank");
        }
      },
      (err) => {
        console.log("BBPS_2 ERROR", err);
        apiErrorToast(err);
      },
    );
  }, []);

  return <Loader loading={loading} />;
};

export default Bbps2;
